// import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCalculator, FaCircleUser, FaIndianRupeeSign } from "react-icons/fa6";
import { FaShareAlt, FaUserTie } from "react-icons/fa";
import { FaFileAlt } from "react-icons/fa";
import { BiTransferAlt } from "react-icons/bi";
import { IoNewspaper } from "react-icons/io5";
import { MdAccountBalanceWallet, MdFormatListBulletedAdd } from "react-icons/md";
import { HiHome } from "react-icons/hi2";
import { MdKeyboardArrowRight } from "react-icons/md";
import { MdKeyboardArrowDown } from "react-icons/md";
import { useState } from 'react';
import { IoMdLogOut, IoMdSettings } from 'react-icons/io';
import { useAuth } from '../contexts/AuthContext'; // Ensure correct path
import { GiWallet } from 'react-icons/gi';

function Sidebar() {
  const [arrow, setarrow] = useState(false)

  const SettingToggle = () => {
    setarrow(!arrow);
  }
  const { logout } = useAuth();

  return (
    <>
      <div className="vertical-menu">
        <div data-simplebar="" className="h-100">
          {/*- Sidemenu */}
          <div id="sidebar-menu">
            {/* Left Menu Start */}
            <ul className="metismenu list-unstyled" id="side-menu">
              <li className="menu-title" data-key="t-menu">
                Menu
              </li>

              <li>
                <Link to="/dashboard">
                  < HiHome />
                  <span data-key="t-dashboard">Dashboard</span>
                </Link>
              </li>
              <li >
                <Link to="/users_table">
                  < FaCircleUser />
                  <span data-key="t-dashboard">Employee</span>
                </Link>
              </li>
              <li>
                <Link to="/oprater_table">
                  < FaUserTie />
                  <span data-key="t-dashboard">Operator</span>
                </Link>
              </li>
              <li>
                <Link to="/fee_collection_table">
                  < FaFileAlt />
                  <span data-key="t-dashboard">Collection Reports</span>
                </Link>
              </li>
              <li>
                <Link to="/transaction_table">
                  <FaShareAlt />
                  <span data-key="t-dashboard">Transactions</span>
                </Link>
              </li>
              <li>
                <Link to="/user_activity">
                  < IoNewspaper />
                  <span data-key="t-dashboard">Logs</span>
                </Link>
              </li>


              <li className={arrow ? "mm-active" : ""} >
                <a href="#" className="" aria-expanded={arrow ? "true" : "false"} onClick={SettingToggle}>
                  <IoMdSettings />
                  <span data-key="t-apps" style={{ marginRight: '5vw' }}>Settings</span>
                  <span className='arrowr'>{arrow ? < MdKeyboardArrowDown /> : <MdKeyboardArrowRight />}</span>
                </a>
                <ul className={arrow ? "sub-menu mm-collapse mm-show" : "sub-menu mm-collapse"} aria-expanded="false">
                  <li className='costomScroll'>
                    {/* <Link to={'/api_log_table'}>
                    <span data-key="t-calendar">Api_Logs</span>
                  </Link> */}
                    <Link to={'/charges_table'}>
                      <span data-key="t-calendar">Charges</span>
                    </Link>
                    <Link to={'/commodity_table'}>
                      <span data-key="t-calendar">Commodity</span>
                    </Link>
                    <Link to={'/device_config_table'}>
                      <span data-key="t-calendar">Device Config</span>
                    </Link>
                    {/* <Link to={'/fee_collection_table'}>
                    <span data-key="t-calendar">Fee Collection</span>
                  </Link> */}

                    {/* <Link to={'/fee_collection_temp_table'}>
                    <span data-key="t-calendar">Fee Collection Temp</span>
                  </Link> */}

                    <Link to={'/fee_type_table'}>
                      <span data-key="t-calendar">Fee Type</span>
                    </Link>
                    <Link to={'/port_table'}>
                      <span data-key="t-calendar">Port</span>
                    </Link>
                    <Link to={'/port_type_table'}>
                      <span data-key="t-calendar">Port Type</span>
                    </Link>
                    <Link to={'/sms_formate_table'}>
                      <span data-key="t-calendar">SMS Formate</span>
                    </Link>
                    <Link to={'/sub_commodity_table'}>
                      <span data-key="t-calendar">Sub Commodity</span>
                    </Link>
                    <Link to={'/sub_sub_commodity_table'}>
                      <span data-key="t-calendar">Sub Sub Commodity</span>
                    </Link>
                    {/* <Link to={'/TransactionTable'}>
                    <span data-key="t-calendar">Transaction</span>
                  </Link> */}
                    <Link to={'/unit_table'}>
                      <span data-key="t-calendar">Unit</span>
                    </Link>
                    {/* <Link to={'/UsersTable'}>
                    <span data-key="t-calendar">Users</span>
                  </Link> */}
                    <Link to={'/vessel_table'}>
                      <span data-key="t-calendar">Vessel</span>
                    </Link>
                    <Link to={'/vessel_type_table'}>
                      <span data-key="t-calendar">Vessel Type</span>
                    </Link>
                    <Link to={'/notification_table'}>
                      <span data-key="t-calendar">Notification</span>
                    </Link>
                    <Link to={'/bank_table'}>
                      <span data-key="t-calendar">Bank</span>
                    </Link>
                    <br />
                    <br />

                  </li>
                </ul>
              </li>

              <li>
                <Link to="/charge_slab_table">
                  <FaIndianRupeeSign />
                  <span data-key="t-dashboard">Charge Slab</span>
                </Link>
              </li>

              <li>
                <Link to="/balance_up_req">
                  <MdAccountBalanceWallet />
                  <span data-key="t-dashboard">Outstanding </span>
                </Link>
              </li>

              <li>
                <Link to="/balance_up_req_all">
                  <GiWallet />
                  <span data-key="t-dashboard">All Outstanding </span>
                </Link>
              </li>

              <li>
                <Link onClick={logout}>
                  <IoMdLogOut />
                  <span data-key="t-dashboard">Log Out</span>
                </Link>
              </li>
            </ul>

          </div>
          {/* Sidebar */}
        </div>
      </div>
    </>

  );
}

export default Sidebar;
